/*
 * Gentle Morrow - quantity tier picker.
 *
 * Buy 2 is the default selection. Buy 1 restores the theme's own buy buttons
 * (keeping Shop Pay express for single purchases); the bundle tiers hide them
 * and use our CTA, because they add a variant belonging to a different product.
 */
(function () {
  'use strict';

  function routes() {
    return window.routes || {};
  }

  function parseJSON(el) {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function init(root) {
    if (!root || root.dataset.gmTierReady === '1') return;
    root.dataset.gmTierReady = '1';

    var packMapEl = root.querySelector('[data-gm-pack-map]');
    var packMap = packMapEl ? parseJSON(packMapEl) : null;
    var isPack = !!packMap;

    var sets = {
      2: { variants: parseJSON(root.querySelector('[data-gm-duo-variants]')), attr: 'data-gm-duo-opt' },
      3: { variants: parseJSON(root.querySelector('[data-gm-trio-variants]')), attr: 'data-gm-trio-opt' },
    };

    /* Pack mode has no per-unit dropdowns - it follows the colour chosen in the
       theme's own variant picker, read fresh at click time so switching colour
       needs no extra wiring. */
    function currentParentVariantId() {
      var input = document.querySelector('product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      if (input && input.value) return String(input.value);
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }
    var cards = root.querySelectorAll('[data-gm-tier-card]');
    var cta = root.querySelector('[data-gm-tier-add]');
    var note = root.querySelector('[data-gm-tier-note]');
    var current = '2';

    function picksFor(tier) {
      return root.querySelector('[data-gm-picks="' + tier + '"]');
    }

    function chosen(tier) {
      if (isPack) {
        var table = packMap[tier];
        if (!table) return null;
        var pid = currentParentVariantId();
        var id = pid ? table[pid] : null;
        return id ? { id: id, a: true } : null;
      }
      var set = sets[tier];
      if (!set || !set.variants.length) return null;
      var wrap = picksFor(tier);
      if (!wrap) return null;
      var selects = wrap.querySelectorAll('[' + set.attr + ']');
      var want = [];
      for (var i = 0; i < selects.length; i++) want.push(selects[i].value);
      for (var v = 0; v < set.variants.length; v++) {
        var o = set.variants[v].o;
        var hit = o.length === want.length;
        for (var j = 0; hit && j < o.length; j++) if (o[j] !== want[j]) hit = false;
        if (hit) return set.variants[v];
      }
      return null;
    }

    function syncCta() {
      var v = chosen(current);
      if (!v || !v.a) {
        cta.setAttribute('disabled', 'disabled');
        cta.textContent = 'That combination is unavailable';
      } else {
        cta.removeAttribute('disabled');
        cta.textContent = current === '3' ? 'Add all three to cart' : 'Add both to cart';
      }
    }

    function select(tier) {
      current = tier;
      for (var i = 0; i < cards.length; i++) {
        var on = cards[i].getAttribute('data-gm-tier-card') === tier;
        cards[i].classList.toggle('is-active', on);
        cards[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      ['2', '3'].forEach(function (t) {
        var p = picksFor(t);
        if (p) p.hidden = t !== tier;
      });
      // the native Add to Cart above stays visible throughout - it is the
      // single-mask option, so nothing here ever hides it
      syncCta();
    }

    for (var i = 0; i < cards.length; i++) {
      (function (card) {
        var tier = card.getAttribute('data-gm-tier-card');
        card.addEventListener('click', function (e) {
          // let the colour dropdowns work without re-triggering selection
          if (e.target && e.target.closest && e.target.closest('.gm-tier__selectwrap')) return;
          select(tier);
        });
        card.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            select(tier);
          }
        });
      })(cards[i]);
    }
    root.addEventListener('change', function (e) {
      if (e.target && e.target.tagName === 'SELECT') syncCta();
    });
    // in pack mode the theme's colour picker drives the bundle, so re-check
    // whenever the shopper changes it
    if (isPack) {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('variant-selects')) {
          setTimeout(syncCta, 60);
        }
      });
    }

    cta.addEventListener('click', function () {
      var v = chosen(current);
      if (!v || !v.a || cta.hasAttribute('disabled')) return;
      var label = cta.textContent;
      cta.setAttribute('disabled', 'disabled');
      cta.textContent = 'Adding…';
      fetch(routes().cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(refreshCart)
        .then(function () {
          cta.removeAttribute('disabled');
          cta.textContent = label;
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.open === 'function') d.open();
        })
        .catch(function () {
          cta.removeAttribute('disabled');
          cta.textContent = label;
        });
    });

    select('2');
    hideLegacyBundleApp();
  }

  /*
   * profit-pumper injects its own Buy 1/2/3 widget through an app embed rather
   * than the theme block, so removing that block does not stop it drawing.
   * Hide it while ours is on the page - the app should still be disabled
   * properly, this only prevents two pickers appearing at once.
   */
  function hideLegacyBundleApp() {
    var sel = '.qb-theme.pumper-bundles, .pumper-bundles.qb-theme';
    function hide() {
      var n = document.querySelectorAll(sel);
      for (var i = 0; i < n.length; i++) n[i].style.display = 'none';
    }
    hide();
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(hide);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () {
      mo.disconnect();
    }, 12000);
  }

  function refreshCart() {
    var drawerInner = document.querySelector('#CartDrawer .drawer__inner');
    var bubble = document.getElementById('cart-icon-bubble');
    var want = [];
    if (drawerInner) want.push('cart-drawer');
    if (bubble) want.push('cart-icon-bubble');
    if (!want.length) return Promise.resolve();
    return fetch(window.location.pathname + '?sections=' + want.join(','), { cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (s) {
        function inner(html, sel) {
          try {
            var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
            return el ? el.innerHTML : null;
          } catch (e) {
            return null;
          }
        }
        if (drawerInner && s['cart-drawer']) {
          var d = inner(s['cart-drawer'], '.drawer__inner');
          if (d !== null) {
            drawerInner.innerHTML = d;
            var renderedDrawer = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
            var liveDrawer = document.querySelector('cart-drawer');
            if (liveDrawer && renderedDrawer) {
              liveDrawer.classList.toggle('is-empty', renderedDrawer.classList.contains('is-empty'));
            }
          }
        }
        if (bubble && s['cart-icon-bubble']) {
          var b = inner(s['cart-icon-bubble'], '.shopify-section');
          if (b !== null) bubble.innerHTML = b;
        }
      })
      .catch(function () {});
  }

  if (window.customElements && !customElements.get('gm-tier-picker')) {
    customElements.define(
      'gm-tier-picker',
      class extends HTMLElement {
        connectedCallback() {
          init(this);
        }
      }
    );
  }
  function boot() {
    var el = document.querySelector('[data-gm-tier]');
    if (el) init(el);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
